import { WidgetComingSoon } from 'features/widgets/Widget';

const CompanyIntegrations = () => {
  return <WidgetComingSoon title='Company Integrations' />;
};

export default CompanyIntegrations;
